var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-upload" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.soloImagen,
            expression: "!soloImagen"
          }
        ],
        staticClass: "file-upload__label"
      },
      [
        _c("input", {
          staticClass: "input-file",
          attrs: { type: "file", id: _vm.id, accept: _vm.extensiones },
          on: { change: _vm.onFileChange }
        }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-upload" }),
        _vm._v(" "),
        _c("label", { attrs: { for: _vm.id } }, [
          _vm._v("Seleccionar archivo...")
        ])
      ]
    ),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "file-upload__image",
      class: { "file-upload__image--open": _vm.fileImage },
      attrs: { src: _vm.image },
      on: { click: _vm.openImage }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d82178a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d82178a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/FileUpload2.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4d82178a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/FileUpload2.vue
// module chunks = 0